import { Route, Routes } from "@angular/router";

import { ConfirmDepositComponent } from "./components/confirm-deposit/confirm-deposit.component";
import { DepositSearchComponent } from "./components/deposit-search/deposit-search.component";
import { EventSearchComponent } from "./components/event-search/event-search.component";
import { HealthCheckComponent } from "./components/healthcheck/healthcheck.component";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { RemittanceEntryComponent } from "./components/remittance-entry/remittance-entry.component";

import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { AuthGuard } from "./guards/auth.guard";
import { FeatureGuard } from "./guards/feature.guard";

import * as _ from "lodash";
import { NoAccessComponent } from "./components/no-access/no-access.component";
import { environment } from "../environments/environment";

export const appRoutes: Routes = [
  {
    path: "",
    component: LandingPageComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
  },
  { path: "healthcheck", component: HealthCheckComponent },
  {
    path: "eventsearch",
    component: EventSearchComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: "MenuItemServiceEventSearch" },
  },
  {
    path: "confirmdeposit",
    component: ConfirmDepositComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: "MenuItemDeposits" },
  },
  {
    path: "depositsearch",
    component: DepositSearchComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: "UI::DepositSearch" },
  },
  {
    path: "remittanceentry",
    component: RemittanceEntryComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: "UI::Get-List::CheckRemittances" },
  },
  {
    path: "no-access",
    component: NoAccessComponent,
  },
  { path: "**", component: PageNotFoundComponent },
];

export function componentFromRoute(route: string): Route {
  let myRoute = _.find(appRoutes, { path: route });
  return myRoute;
}



// WEBPACK FOOTER //
// ./src/app/routes.ts